import { render } from "./VSkeleton.vue?vue&type=template&id=adc0568e"
import script from "./VSkeleton.vue?vue&type=script&lang=js"
export * from "./VSkeleton.vue?vue&type=script&lang=js"

import "./VSkeleton.vue?vue&type=style&index=0&id=adc0568e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__